import DesignData from './DesignData';
import { getProperty, getStringProperty } from '../utils/utils';

// ==================================================================================================
export interface ISubmitRequest {
  url?: string;
}

// ==================================================================================================
export interface IConfigData {
  projectId?: string;
  mainColor?: string;
  secondColor?: string;
  thirdColor?: string;
  submitRequest?: ISubmitRequest;
}

export default class Config {
  // ================================================================================================
  // properties
  // ================================================================================================
  private _data: IConfigData;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor() {
    this.parse();
  }

  // ----------------------------------------------------------------------------------------------
  get data(): IConfigData {
    return (this._data);
  }

  // ----------------------------------------------------------------------------------------------
  async load(resourceUrl: string): Promise<IConfigData> {
    const promise = new Promise((resolve, reject) => {
      fetch(resourceUrl)
        .then((response) => {
          if (!response.ok) {
            reject(response);
          }

          return (response.json());
        })

        .then((data) => {
          if (data) {
            this.parse(data);
            resolve(this.data);
          } else {
            reject(new Error('no data'));
          }
        })

        .catch((error) => {
          reject(error);
        });
    });

    return (promise);
  }

  // ================================================================================================
  // private
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  private parse(data?: unknown): void {
    data = data || {};

    this._data = {
      projectId: getStringProperty(data, 'projectId', ''),
      mainColor: getStringProperty(data, 'mainColor', DesignData.DEFAULT_MAIN_COLOR),
      secondColor: getStringProperty(data, 'secondColor', DesignData.DEFAULT_SECOND_COLOR),
      thirdColor: getStringProperty(data, 'thirdColor', DesignData.DEFAULT_THIRD_COLOR),
      submitRequest: Config.ParseSubmitRequest(getProperty(data, 'submitRequest', {})),
    };
  }

  // ----------------------------------------------------------------------------------------------
  private static ParseSubmitRequest(data?: unknown): ISubmitRequest {
    const submitRequest: ISubmitRequest = {
      url: getStringProperty(data, 'url', ''),
    };

    return (submitRequest);
  }
}
